import { configureStore } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

const session = createSlice({
    name: "session",
    initialState: {
        value: null,
    },
    reducers: {
        saveSession: (state, action) => {
            state.value = action.payload;
        },
        removeSession: (state) => {
            state.value = null;
        },
    },
});

const chatInfo = createSlice({
    name: "chatInfo",
    initialState: {
        value: null,
    },
    reducers: {
        setChatInfo: (state, action) => {
            state.value = action.payload;
        },
        unsetChatInfo: (state) => {
            state.value = null;
        },
    },
});

export const { saveSession, removeSession } = session.actions;
export const { setChatInfo, unsetChatInfo } = chatInfo.actions;

export default configureStore({
    reducer: {
        session: session.reducer,
        chatInfo: chatInfo.reducer,
    },
});
